import { ValueWithRandom } from "../../../ValueWithRandom";
export class MovePathDelay extends ValueWithRandom {
    constructor() {
        super();
    }
}
